<template>
	<div>
		<v-toolbar flat color="white">
			<v-toolbar-title>{{ $t('groups.title') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn class="ml-2" small fab color="primary" @click="addNewGroup">
				<v-icon>add</v-icon>
			</v-btn>
		</v-toolbar>
		<v-data-table
				:headers="headers"
				:items="groupDetails"
				:single-expand="false"
				:expanded.sync="expanded"
				item-key="name"
				show-expand
				class="elevation-2">
			<template v-slot:expanded-item="{ item }">
				<td :colspan="headers.length">
					<groups-table-item :group="item" @updateGroup="updateGroup" @createGroup="createGroup"
														 @removeGroup="deleteGroup"></groups-table-item>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import GroupsTableItem from './groups-table-item';

export default {
	name: 'GroupListItem',
	components: { GroupsTableItem },
	props: {
		groups: {
			type: Array,
		}
	},
	data() {
		return {
			expanded: [],
			groupDetails: [],
			hover: false,
			showConfirmDeleteDialog: false,
		};
	},
	computed: {
		headers() {
			return [
				{
					text: this.$t('groups.table.name'),
					align: 'left',
					sortable: true,
					value: 'name'
				},
				{
					text: this.$t('groups.table.user-count'),
					align: 'left',
					sortable: true,
					value: 'count'
				},
				{ text: '', value: 'data-table-expand' },
			];
		}
	},
	watch: {
		groups(groups) {
			this.groupDetails = JSON.parse(JSON.stringify(groups));
		}
	},
	methods: {
		...mapActions({
			createGroup: 'group/createGroup',
			updateGroup: 'group/updateGroup',
			deleteGroup: 'group/deleteGroup'
		}),
		addNewGroup() {
			const newGroup = {
				name: '',
			};
			this.groupDetails.push(newGroup);
			this.expanded.push(newGroup);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/styles/colors";

::v-deep .v-data-table-header {
	background-color: $light-grey;
}
</style>
